import { useEffect, useState } from 'react';
import { getCurrentTokenWithoutRedirect, getOxygenId } from '@adsk/acs-sc-web-platform-api';
export const useOxygenId = () => {
  const [oxygenId, setOxygenId] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    async function extractToken() {
      setLoading(true);
      try {
        const token = await getCurrentTokenWithoutRedirect();
        setOxygenId(getOxygenId(token.accessToken));
      } catch (currentError) {
        setError(currentError);
      } finally {
        setLoading(false);
      }
    }
    void extractToken();
  }, []);
  return {
    oxygenId,
    error,
    loading
  };
};
//# sourceMappingURL=useOxygenId.js.map